import Vue from "vue";
class DashboardService {

    GetTopTree(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-chart-top-tree",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    GetOrigin(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-chart-origin/",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    GetHeigthClass(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-chart-pie-heigth-class/",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    GetPieOrigin(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-chart-pie-origin/",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    GetGaau(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-chart-gaau/",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    GetTotalCard(projetcs) {
        return Vue.prototype.$http({
            url: "dashboard/get-total-card/",
            data: { ids: projetcs },
            method: "POST"
        });
    }

    ToTopTree(model) {
        return {
            exporting: {
                chartOptions: {
                    chart: {
                        width: 790 // largura em pixels da folha A4 na orientação retrato
                    }
                }
            },
            scale: 0.8,
            chart: {
                type: "bar"
            },
            title: {
                text: "Indicação das 10 espécies com maior representatividade de indivíduos arbóreos/palmeiras"
            },
            xAxis: {
                categories: model.categories
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Indivíduos avaliados (N)",
                },

            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,

                    }
                }
            },
            colors: ['#009933'],
            series: [
                {
                    name: "",
                    colorByPoint: true,
                    data: model.itens
                }
            ]
        };
    }

    ToColumn(model, title, colors, titleX) {

        let series = [
            {
                name: "",
                colorByPoint: true,
                data: []
            }
        ];

        if (model.itens)
            series[0].data = model.itens;
        else
            series = model.series;

        return {
            exporting: {
                chartOptions: {
                    chart: {
                        width: 790 // largura em pixels da folha A4 na orientação retrato
                    }
                }
            },
            scale: 0.8,
            chart: {
                type: "column"
            },
            title: {
                text: title
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Indivíduos avaliados (N)",
                },

            },

            xAxis: {
                categories: model.categories,
                crosshair: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            colors: colors,
            series: series
        };
    }



    ToPie(model, title) {
        return {
            chart: {
                type: "pie"
            },
            title: {
                text: title
            },
            tooltip: {
                headerFormat: ""
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            colors: ['#052c27', '#b0cb07', '#92d050'],
            series: [
                {
                    minPointSize: 10,
                    innerSize: "30%",
                    zMin: 0,
                    name: "",
                    data: model
                }
            ]
        };
    }


}

export default new DashboardService();
